import { render, staticRenderFns } from "./BookingTalentNotificationsModal.vue?vue&type=template&id=ea36f6b0"
import script from "./BookingTalentNotificationsModal.vue?vue&type=script&lang=js"
export * from "./BookingTalentNotificationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports